/**
 * CriteriaDescriptionTerm
 */
import React from 'react';
import clsx from 'clsx';
/** Main description for this component. */
var CriteriaDescriptionTerm = function (_a) {
    var text = _a.text;
    return (React.createElement("dt", { className: clsx('w-32 flex-none font-semibold text-h4 leading-6') }, text + ":"));
};
export default CriteriaDescriptionTerm;
